// extracted by mini-css-extract-plugin
module.exports = {"placeholderWithError":"styles_placeholderWithError___5uKu","placeholderContainer":"styles_placeholderContainer__HlXsF","errorContainer":"styles_errorContainer__nNDR6"};